module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1023-c7d9e0c92346713c631f9a3cdd27b8a4.png";